import { Camera, OrthographicCamera, PerspectiveCamera } from "three";

export class RenderCamera {

    private currentCamera: PerspectiveCamera | OrthographicCamera;

    public get current(): PerspectiveCamera | OrthographicCamera {
        return this.currentCamera;
    }

    public set current(camera: PerspectiveCamera | OrthographicCamera) {
        this.currentCamera = camera ?? this.defaultCamera;
    }

    public set aspect(value: number) {
        if (this.current instanceof PerspectiveCamera) {
            this.current.aspect = value;
        }
    }

    public constructor(
        private readonly defaultCamera: PerspectiveCamera | OrthographicCamera
    ) {
        if (defaultCamera == null) {
            throw new Error("You should provide configured Camera as default value for RenderCamera.");
        }
        this.current = defaultCamera;
    }

}